var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { clearable: "", placeholder: "请输入产品名称" },
            model: {
              value: _vm.listQuery.name,
              callback: function($$v) {
                _vm.$set(_vm.listQuery, "name", $$v)
              },
              expression: "listQuery.name"
            }
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission",
                  value: ["GET /admin/product/list"],
                  expression: "['GET /admin/product/list']"
                }
              ],
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.handleFilter }
            },
            [_vm._v("查找")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission",
                  value: ["POST /admin/product/create"],
                  expression: "['POST /admin/product/create']"
                }
              ],
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-edit" },
              on: { click: _vm.handleCreate }
            },
            [_vm._v("添加")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading"
            }
          ],
          attrs: {
            data: _vm.list,
            "element-loading-text": "正在查询中。。。",
            border: "",
            fit: "",
            "highlight-current-row": ""
          }
        },
        [
          _c("el-table-column", {
            attrs: { align: "left", label: "名称", prop: "pName", width: "250" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "center", label: "产品编码", prop: "pNo" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "left",
              label: "版本",
              prop: "pVersion",
              sortable: ""
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "left", label: "类型", prop: "pType" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "center", label: "阶段", prop: "pStage" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.pStage == 0
                      ? _c("el-tag", { attrs: { type: "primary" } }, [
                          _vm._v("无")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.pStage == 1
                      ? _c("el-tag", { attrs: { type: "primary" } }, [
                          _vm._v("一阶段")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.pStage == 2
                      ? _c("el-tag", { attrs: { type: "primary" } }, [
                          _vm._v("二阶段")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.pStage == 3
                      ? _c("el-tag", { attrs: { type: "primary" } }, [
                          _vm._v("三阶段")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.pStage == 4
                      ? _c("el-tag", { attrs: { type: "primary" } }, [
                          _vm._v("四阶段")
                        ])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "left", label: "CRM编号", prop: "crmNo" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "left", label: "选中提醒", prop: "pNotify" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "center", label: "状态", prop: "deleted" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.deleted == true
                      ? _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v("已停用")
                        ])
                      : _c("span", [_vm._v("正常")])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "操作",
              width: "250",
              "class-name": "small-padding fixed-width"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: ["POST /admin/product/update"],
                            expression: "['POST /admin/product/update']"
                          }
                        ],
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.handleUpdate(scope.row)
                          }
                        }
                      },
                      [_vm._v("编辑")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: ["POST /admin/product/delete"],
                            expression: "['POST /admin/product/delete']"
                          }
                        ],
                        attrs: { type: "danger", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.handleDelete(scope.row)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0"
          }
        ],
        attrs: {
          total: _vm.total,
          page: _vm.listQuery.page,
          limit: _vm.listQuery.limit
        },
        on: {
          "update:page": function($event) {
            return _vm.$set(_vm.listQuery, "page", $event)
          },
          "update:limit": function($event) {
            return _vm.$set(_vm.listQuery, "limit", $event)
          },
          pagination: _vm.getList
        }
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.textMap[_vm.dialogStatus],
            visible: _vm.dialogFormVisible,
            width: "660px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "dataForm",
              staticStyle: { width: "400px", "margin-left": "50px" },
              attrs: {
                rules: _vm.rules,
                model: _vm.dataForm,
                "status-icon": "",
                "label-position": "left",
                "label-width": "100px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "名称", prop: "pName" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: { placeholder: "产品名称" },
                    model: {
                      value: _vm.dataForm.pName,
                      callback: function($$v) {
                        _vm.$set(_vm.dataForm, "pName", $$v)
                      },
                      expression: "dataForm.pName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "100%" },
                  attrs: { label: "产品编号", prop: "pNo" }
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "产品在DRM平台的编号" },
                    model: {
                      value: _vm.dataForm.pNo,
                      callback: function($$v) {
                        _vm.$set(_vm.dataForm, "pNo", $$v)
                      },
                      expression: "dataForm.pNo"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "产品版本", prop: "pVersion" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "filter-item",
                      staticStyle: { width: "100%" },
                      attrs: { clearable: "", placeholder: "请选择产品版本" },
                      model: {
                        value: _vm.dataForm.pVersion,
                        callback: function($$v) {
                          _vm.$set(_vm.dataForm, "pVersion", $$v)
                        },
                        expression: "dataForm.pVersion"
                      }
                    },
                    _vm._l(_vm.versionOptions, function(type) {
                      return _c("el-option", {
                        key: type.id,
                        attrs: { label: type.name, value: type.id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "产品类型", prop: "pType" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "filter-item",
                      staticStyle: { width: "100%" },
                      attrs: { clearable: "", placeholder: "请选择产品类型" },
                      model: {
                        value: _vm.dataForm.pType,
                        callback: function($$v) {
                          _vm.$set(_vm.dataForm, "pType", $$v)
                        },
                        expression: "dataForm.pType"
                      }
                    },
                    _vm._l(_vm.typeOptions, function(type) {
                      return _c("el-option", {
                        key: type.id,
                        attrs: { label: type.name, value: type.id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "CRM编号", prop: "crmNo" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "产品在CRM平台的编号" },
                    model: {
                      value: _vm.dataForm.crmNo,
                      callback: function($$v) {
                        _vm.$set(_vm.dataForm, "crmNo", $$v)
                      },
                      expression: "dataForm.crmNo"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "描述", prop: "remark" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "简单产品描述" },
                    model: {
                      value: _vm.dataForm.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.dataForm, "remark", $$v)
                      },
                      expression: "dataForm.remark"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialogFormVisible = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _vm.dialogStatus == "create"
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.createData }
                    },
                    [_vm._v("确定")]
                  )
                : _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.updateData }
                    },
                    [_vm._v("确定")]
                  )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }